import {
  colorMonteverde,
  colorKolkata,
  colorPanjin,
} from '@skyscanner/bpk-foundations-web/tokens/base.es6';

type Score = {
  threshold: number;
  summary: string;
  color: string;
};

const scoreBracketsForReview: Score[] = [
  { threshold: 0, summary: 'rating_below_average', color: colorPanjin },
  { threshold: 1.5, summary: 'rating_average', color: colorPanjin },
  { threshold: 3, summary: 'rating_satisfactory', color: colorKolkata },
  { threshold: 3.5, summary: 'rating_good', color: colorKolkata },
  { threshold: 4, summary: 'rating_very_good', color: colorMonteverde },
  { threshold: 4.5, summary: 'rating_excellent', color: colorMonteverde },
  { threshold: 5, summary: 'rating_with_honors', color: colorMonteverde },
];

const scoreSummaryForReview = (number: number) =>
  scoreBracketsForReview.reduce<undefined | string>(
    (foundSummary, value, idx) => {
      const { summary, threshold } = value;
      const maxIdx = scoreBracketsForReview.length - 1;
      const gapIdx = Math.min(maxIdx, idx + 1);
      const gap =
        scoreBracketsForReview[gapIdx].threshold -
        scoreBracketsForReview[idx].threshold;

      if (foundSummary) {
        return foundSummary;
      }

      if (number - gap >= threshold && idx < maxIdx) {
        return undefined;
      }
      return summary;
    },
    undefined,
  );

export default scoreSummaryForReview;
